import get from 'lodash/get';
import ContentItemWithResolver from "models/ContentItemWithResolver";

export default class HeroHeadingText extends ContentItemWithResolver {
	get headingText(): string {
		return get(this, '_heading_text.value', '');
	}
}
